// src/opsgenie/team/types.ts
var OpsgenieTeamAriResourceOwner = "opsgenie", OpsgenieTeamAriResourceType = "team";

export {
  OpsgenieTeamAriResourceOwner,
  OpsgenieTeamAriResourceType
};
